module.exports = __webpack_public_path__ + "static/13-707d1823bf7e3f101d8fe1aa97cbd5b4.png";